import { useEffect, useState } from "react";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./App.css";
import { ExpandedContext } from "./contexts/Expanded";
import { LoadingContext } from "./contexts/LoadingContext";
import AppRoutes from "./routes/AppRoutes";
import { SearchContext } from "./contexts/SearchContext";
import { PermissionsContext } from "./contexts/PermissionsContext";
import { asyncLocalStorage, getPermissions } from "./utils/storage";
import {
  firebaseConfig,
  onMessageListener,
  requestPermission,
} from "./utils/firebase";
import { successToast } from "./utils/helper-ui";
import { updatePushToken } from "./services/AuthApi";

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [search, setSearch] = useState<string>("");
  const [permissions, setPermissions] = useState<string[]>([]);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications"
        ) ||
        e.message.includes("Permission Exists")
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    getPermissions().then((res) => {
      setPermissions(res);
    });
    setMounted(true);


  }, []);

  useEffect(() => {
    if (!mounted) {
      return;
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("../firebase-messaging-sw.js")
        .then(async (registration) => {
          // console.log("Registration successful, scope is:", registration.scope);
          let token = await requestPermission();
          // console.log(token);
          if (token) {
            await updatePushToken({
              device_type: "web",
              type: "fcm",
              token,
            });
          }
        })
        .catch(function (err) {
          console.log("Service worker registration failed, error:", err);
        });
    }

    const initMessaging = async () => {
      try {
        let res = await onMessageListener();
        successToast(res.notification.body);
      } catch (error) {
        console.error(error);
      }
    };
    asyncLocalStorage.getItem("IS_EXPANDED").then((val) => {
      setIsExpanded(val === "1");
    });
    initMessaging();
  }, [mounted]);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      <ExpandedContext.Provider value={{ isExpanded, setIsExpanded : (val) => {
        asyncLocalStorage.setItem("IS_EXPANDED", val ? "1": "0");
        setIsExpanded(val);
      } }}>
        <PermissionsContext.Provider
          value={{
            permissions,
            setPermissions: (val) => {
              setPermissions(val);
            },
          }}
        >
          <SearchContext.Provider value={{ search, setSearch }}>
            <AppRoutes />
          </SearchContext.Provider>
        </PermissionsContext.Provider>
      </ExpandedContext.Provider>
    </LoadingContext.Provider>
  );
}

export default App;
